module.exports = __webpack_public_path__ + "static/media/key-stop-icon.1005918c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/route-finder/key-stop-icon.svg
// module id = 884
// module chunks = 0